export interface IUserTokenData {
    isInvitation: boolean;
    time: number;
    expireTime: number;
    modifyUserId: string;
}

export class UserTokenData implements IUserTokenData {
    isInvitation: boolean;
    time: number;
    expireTime: number;
    modifyUserId: string;

    constructor();
    constructor(obj: IUserTokenData);
    constructor(obj?: any) {
        this.isInvitation = obj && obj.isInvitation || false;
        this.time = obj && obj.time || null;
        this.expireTime = obj && obj.expireTime || null;
        this.modifyUserId = obj && obj.modifyUserId || "";
    }
}